export const recipes = [
  {
    id: 'challah',
    title: 'Classic Challah',
    time: '3 hours',
    difficulty: 'Medium',
    image: '🍞',
    imageSearchQuery: 'braided bread challah',
    description: 'The traditional braided bread that welcomes Shabbat',
    culturalContext: 'Challah is more than bread—it\'s a symbol of connection. The braids represent unity, and the act of breaking bread together creates sacred moments. Many families have their own braiding traditions passed down through generations.',
    ingredients: [
      { name: 'All-purpose flour', amount: '4 cups' },
      { name: 'Active dry yeast', amount: '2 1/4 tsp' },
      { name: 'Warm water', amount: '1 cup' },
      { name: 'Eggs', amount: '2 large' },
      { name: 'Honey', amount: '1/4 cup' },
      { name: 'Olive oil', amount: '1/4 cup' },
      { name: 'Salt', amount: '1 tsp' },
      { name: 'Sesame seeds', amount: '2 tbsp (optional)' },
    ],
    instructions: [
      'Dissolve yeast in warm water with a pinch of honey. Let sit until foamy, about 5 minutes.',
      'In a large bowl, mix flour and salt. Make a well in the center.',
      'Add eggs, honey, and olive oil to the yeast mixture. Pour into the flour well.',
      'Mix until a shaggy dough forms, then knead on a floured surface for 8-10 minutes until smooth and elastic.',
      'Place in an oiled bowl, cover, and let rise for 1-2 hours until doubled.',
      'Divide dough into 3 or 6 equal pieces. Roll each into a long rope.',
      'Braid the ropes together. For a 3-strand braid: cross right over middle, left over middle, repeat.',
      'Place on a baking sheet, cover, and let rise 30-45 minutes.',
      'Brush with egg wash and sprinkle with sesame seeds if desired.',
      'Bake at 375°F for 25-30 minutes until golden brown. Let cool before slicing.',
    ],
  },
  {
    id: 'brisket',
    title: 'Slow-Cooked Brisket',
    time: '4-5 hours',
    difficulty: 'Easy',
    image: '🍖',
    imageSearchQuery: 'brisket beef in gravy',
    description: 'Tender, flavorful brisket that falls apart',
    culturalContext: 'Brisket is the centerpiece of many Jewish holiday meals. The long, slow cooking process mirrors the patience and care we bring to our traditions. It\'s often the dish that brings everyone to the table.',
    ingredients: [
      { name: 'Beef brisket', amount: '4-5 lbs' },
      { name: 'Onions', amount: '3 large, sliced' },
      { name: 'Garlic', amount: '6 cloves, minced' },
      { name: 'Beef broth', amount: '2 cups' },
      { name: 'Red wine', amount: '1 cup' },
      { name: 'Tomato paste', amount: '2 tbsp' },
      { name: 'Bay leaves', amount: '2' },
      { name: 'Thyme', amount: '1 tsp' },
      { name: 'Salt and pepper', amount: 'to taste' },
    ],
    instructions: [
      'Preheat oven to 325°F. Season brisket generously with salt and pepper.',
      'Heat oil in a large Dutch oven. Sear brisket on both sides until browned, about 5 minutes per side.',
      'Remove brisket and add onions. Cook until soft, about 10 minutes.',
      'Add garlic, tomato paste, and herbs. Cook 1 minute.',
      'Add wine and broth. Bring to a simmer.',
      'Return brisket to pot, fat side up. Cover and transfer to oven.',
      'Cook 3-4 hours until fork-tender. Let rest 20 minutes before slicing.',
      'Slice against the grain and serve with pan juices.',
    ],
  },
  {
    id: 'latkes',
    title: 'Crispy Potato Latkes',
    time: '45 minutes',
    difficulty: 'Easy',
    image: '🥔',
    imageSearchQuery: 'latkes',
    description: 'Golden, crispy potato pancakes for Hanukkah',
    culturalContext: 'Latkes celebrate the miracle of oil during Hanukkah. The sizzle of potatoes in hot oil connects us to a story thousands of years old. Making them together is a family tradition in itself.',
    ingredients: [
      { name: 'Russet potatoes', amount: '2 lbs' },
      { name: 'Yellow onion', amount: '1 medium' },
      { name: 'Eggs', amount: '2 large' },
      { name: 'Matzo meal or flour', amount: '3 tbsp' },
      { name: 'Salt', amount: '1 tsp' },
      { name: 'Black pepper', amount: '1/2 tsp' },
      { name: 'Vegetable oil', amount: 'for frying' },
      { name: 'Applesauce and sour cream', amount: 'for serving' },
    ],
    instructions: [
      'Peel and grate potatoes. Place in a clean kitchen towel and squeeze out excess liquid.',
      'Grate onion and mix with potatoes.',
      'Add eggs, matzo meal, salt, and pepper. Mix well.',
      'Heat 1/4 inch of oil in a large skillet over medium-high heat.',
      'Drop spoonfuls of mixture into hot oil. Flatten slightly with spatula.',
      'Fry 3-4 minutes per side until golden and crispy.',
      'Drain on paper towels. Serve hot with applesauce and sour cream.',
    ],
  },
  {
    id: 'charoset',
    title: 'Apple Charoset',
    time: '15 minutes',
    difficulty: 'Easy',
    image: '🍎',
    imageSearchQuery: 'apples nuts charoset passover',
    description: 'Sweet Passover haroset with apples and nuts',
    culturalContext: 'Charoset represents the mortar used by enslaved Israelites in Egypt. The sweetness reminds us that even in hardship, there is hope. Each family\'s recipe is unique, passed down like a story.',
    ingredients: [
      { name: 'Apples', amount: '3 medium, peeled and diced' },
      { name: 'Walnuts', amount: '1/2 cup, chopped' },
      { name: 'Sweet red wine', amount: '1/4 cup' },
      { name: 'Honey', amount: '2 tbsp' },
      { name: 'Cinnamon', amount: '1 tsp' },
      { name: 'Dates', amount: '3-4, pitted and chopped (optional)' },
    ],
    instructions: [
      'Combine diced apples and walnuts in a bowl.',
      'Add wine, honey, and cinnamon. Mix well.',
      'Stir in dates if using.',
      'Let sit 30 minutes to allow flavors to meld.',
      'Serve at room temperature. Can be made 1 day ahead.',
    ],
  },
  {
    id: 'matzo-ball-soup',
    title: 'Matzo Ball Soup',
    time: '2 hours',
    difficulty: 'Medium',
    image: '🍲',
    imageSearchQuery: 'matzo ball soup chicken',
    description: 'Comforting soup with fluffy matzo balls',
    culturalContext: 'Matzo ball soup is Jewish comfort food. It\'s the dish that says "home" and "you\'re loved." Whether your matzo balls are light and fluffy or dense and chewy, they carry memories of family gatherings.',
    ingredients: [
      { name: 'Chicken broth', amount: '8 cups' },
      { name: 'Matzo meal', amount: '1 cup' },
      { name: 'Eggs', amount: '4 large' },
      { name: 'Chicken fat or oil', amount: '1/4 cup' },
      { name: 'Salt', amount: '1 tsp' },
      { name: 'Carrots', amount: '2, sliced' },
      { name: 'Celery', amount: '2 stalks, sliced' },
      { name: 'Fresh dill', amount: '2 tbsp, chopped' },
    ],
    instructions: [
      'Beat eggs with chicken fat/oil and salt. Mix in matzo meal.',
      'Cover and refrigerate 30 minutes.',
      'Bring broth to a boil. Add carrots and celery.',
      'Form matzo mixture into 1-inch balls with wet hands.',
      'Drop balls into boiling broth. Cover and simmer 20 minutes.',
      'Garnish with fresh dill before serving.',
    ],
  },
  {
    id: 'hamantaschen',
    title: 'Hamantaschen',
    time: '1.5 hours',
    difficulty: 'Medium',
    image: '🍪',
    imageSearchQuery: 'hamantaschen cookies purim',
    description: 'Triangle-shaped cookies for Purim',
    culturalContext: 'Hamantaschen are named for Haman, the villain of the Purim story. The triangular shape represents his hat. Making them is a playful way to remember that good triumphs over evil—and that we can celebrate with cookies!',
    ingredients: [
      { name: 'All-purpose flour', amount: '2 1/2 cups' },
      { name: 'Sugar', amount: '1/2 cup' },
      { name: 'Butter', amount: '1/2 cup, softened' },
      { name: 'Eggs', amount: '2 large' },
      { name: 'Vanilla extract', amount: '1 tsp' },
      { name: 'Fruit preserves', amount: '1 cup (apricot, raspberry, or poppy seed)' },
    ],
    instructions: [
      'Cream butter and sugar. Beat in eggs and vanilla.',
      'Gradually mix in flour until dough forms.',
      'Wrap and chill 1 hour.',
      'Roll out to 1/4 inch thick. Cut into 3-inch circles.',
      'Place 1 tsp filling in center of each circle.',
      'Fold edges to form triangle, pinching corners.',
      'Bake at 350°F for 15-18 minutes until golden.',
    ],
  },
  {
    id: 'shakshuka',
    title: '15-Minute Shakshuka',
    time: '15 minutes',
    difficulty: 'Easy',
    image: '🍳',
    imageSearchQuery: 'shakshuka',
    description: 'Easy weeknight dinner the kids actually love',
    culturalContext: 'Shakshuka, while popular in Israel, has become a beloved dish in many Jewish homes. It\'s quick, nourishing, and perfect for busy families. The eggs poached in tomato sauce represent the warmth and comfort of home.',
    ingredients: [
      { name: 'Olive oil', amount: '2 tbsp' },
      { name: 'Onion', amount: '1 medium, diced' },
      { name: 'Bell pepper', amount: '1, diced' },
      { name: 'Garlic', amount: '3 cloves, minced' },
      { name: 'Canned tomatoes', amount: '1 can (14 oz), crushed' },
      { name: 'Paprika', amount: '1 tsp' },
      { name: 'Cumin', amount: '1/2 tsp' },
      { name: 'Eggs', amount: '4-6 large' },
      { name: 'Fresh parsley', amount: 'for garnish' },
      { name: 'Feta cheese', amount: 'optional' },
    ],
    instructions: [
      'Heat oil in a large skillet over medium heat.',
      'Add onion and bell pepper. Cook 5 minutes until soft.',
      'Add garlic, paprika, and cumin. Cook 1 minute.',
      'Add tomatoes and simmer 5 minutes.',
      'Make wells in the sauce and crack eggs into them.',
      'Cover and cook 5-7 minutes until eggs are set.',
      'Garnish with parsley and feta. Serve with bread.',
    ],
  },
  {
    id: 'rugelach',
    title: 'Cinnamon Rugelach',
    time: '2 hours',
    difficulty: 'Medium',
    image: '🥐',
    imageSearchQuery: 'chocolate croissant jewish',
    description: 'Flaky, sweet pastries perfect for holidays',
    culturalContext: 'Rugelach are crescent-shaped pastries that appear at many Jewish celebrations. The rolling and shaping is a meditative process, and sharing them is an act of love.',
    ingredients: [
      { name: 'Cream cheese', amount: '8 oz, softened' },
      { name: 'Butter', amount: '1 cup, softened' },
      { name: 'All-purpose flour', amount: '2 cups' },
      { name: 'Sugar', amount: '1/4 cup' },
      { name: 'Salt', amount: '1/4 tsp' },
      { name: 'Brown sugar', amount: '1/2 cup' },
      { name: 'Cinnamon', amount: '2 tsp' },
      { name: 'Raisins or chocolate chips', amount: '1/2 cup' },
      { name: 'Egg wash', amount: '1 egg beaten with 1 tbsp water' },
    ],
    instructions: [
      'Beat cream cheese and butter until smooth.',
      'Mix in flour, sugar, and salt until dough forms.',
      'Divide into 4 disks. Wrap and chill 1 hour.',
      'Mix brown sugar, cinnamon, and raisins/chips.',
      'Roll each disk into a circle. Sprinkle with filling.',
      'Cut into 8 wedges. Roll each from wide end to point.',
      'Place on baking sheet. Brush with egg wash.',
      'Bake at 350°F for 20-25 minutes until golden.',
    ],
  },
  {
    id: 'tzimmes',
    title: 'Sweet Tzimmes',
    time: '1.5 hours',
    difficulty: 'Easy',
    image: '🥕',
    imageSearchQuery: 'carrots sweet potatoes rosh hashanah',
    description: 'Sweet carrot and fruit stew for Rosh Hashanah',
    culturalContext: 'Tzimmes means "a big fuss" in Yiddish, but it\'s also a sweet dish that symbolizes our hopes for a sweet new year. The carrots represent gold coins—prosperity for the year ahead.',
    ingredients: [
      { name: 'Carrots', amount: '2 lbs, sliced' },
      { name: 'Sweet potatoes', amount: '2 large, cubed' },
      { name: 'Prunes', amount: '1 cup, pitted' },
      { name: 'Dried apricots', amount: '1/2 cup' },
      { name: 'Honey', amount: '1/4 cup' },
      { name: 'Orange juice', amount: '1/2 cup' },
      { name: 'Cinnamon', amount: '1 tsp' },
      { name: 'Salt', amount: '1/2 tsp' },
    ],
    instructions: [
      'Preheat oven to 350°F.',
      'Combine all ingredients in a large baking dish.',
      'Cover with foil and bake 1 hour.',
      'Uncover and bake 30 minutes until tender and glazed.',
      'Serve warm or at room temperature.',
    ],
  },
  {
    id: 'kugel',
    title: 'Noodle Kugel',
    time: '1.5 hours',
    difficulty: 'Easy',
    image: '🍝',
    imageSearchQuery: 'noodle kugel baked',
    description: 'Sweet noodle pudding, a Shabbat favorite',
    culturalContext: 'Kugel is the ultimate comfort food. Whether sweet or savory, it\'s a dish that says "home" and "family." Every family has their own version, passed down through generations.',
    ingredients: [
      { name: 'Wide egg noodles', amount: '1 lb' },
      { name: 'Cottage cheese', amount: '16 oz' },
      { name: 'Sour cream', amount: '1 cup' },
      { name: 'Cream cheese', amount: '8 oz, softened' },
      { name: 'Eggs', amount: '4 large' },
      { name: 'Sugar', amount: '1/2 cup' },
      { name: 'Vanilla extract', amount: '1 tsp' },
      { name: 'Raisins', amount: '1/2 cup (optional)' },
      { name: 'Cinnamon', amount: '1 tsp' },
    ],
    instructions: [
      'Cook noodles according to package. Drain and cool.',
      'Mix cottage cheese, sour cream, and cream cheese.',
      'Beat in eggs, sugar, and vanilla.',
      'Stir in noodles and raisins if using.',
      'Pour into greased 9x13 baking dish.',
      'Sprinkle with cinnamon.',
      'Bake at 350°F for 45-50 minutes until golden.',
      'Let cool 15 minutes before serving.',
    ],
  },
  {
    id: 'roasted-chicken',
    title: 'Shabbat Roasted Chicken',
    time: '1.5 hours',
    difficulty: 'Easy',
    image: '🍗',
    imageSearchQuery: 'roasted chicken',
    description: 'Simple, flavorful chicken for Friday night',
    culturalContext: 'Roasted chicken is a Shabbat staple. The aroma fills the house, signaling that the week is ending and sacred time is beginning. It\'s a dish that brings everyone to the table.',
    ingredients: [
      { name: 'Whole chicken', amount: '4-5 lbs' },
      { name: 'Lemon', amount: '1, halved' },
      { name: 'Garlic', amount: '6 cloves' },
      { name: 'Fresh herbs', amount: 'rosemary, thyme, sage' },
      { name: 'Olive oil', amount: '2 tbsp' },
      { name: 'Salt and pepper', amount: 'to taste' },
      { name: 'Onions', amount: '2, quartered' },
      { name: 'Carrots', amount: '4, cut into chunks' },
    ],
    instructions: [
      'Preheat oven to 425°F.',
      'Pat chicken dry. Season inside and out with salt and pepper.',
      'Stuff cavity with lemon, garlic, and herbs.',
      'Tuck wings under. Tie legs together.',
      'Place on bed of onions and carrots in roasting pan.',
      'Drizzle with olive oil.',
      'Roast 15 minutes, then reduce to 375°F.',
      'Roast 1 hour until internal temperature reaches 165°F.',
      'Let rest 15 minutes before carving.',
    ],
  },
  {
    id: 'sufganiyot',
    title: 'Sufganiyot (Hanukkah Donuts)',
    time: '2 hours',
    difficulty: 'Medium',
    image: '🍩',
    imageSearchQuery: 'jelly donuts fried pastries hanukkah',
    description: 'Sweet jelly-filled donuts for Hanukkah',
    culturalContext: 'Sufganiyot are fried in oil, just like latkes, to remember the miracle of Hanukkah. The round shape represents the cycle of the year and the continuity of our traditions. Making them together is a messy, joyful experience that kids love.',
    ingredients: [
      { name: 'All-purpose flour', amount: '3 1/2 cups' },
      { name: 'Active dry yeast', amount: '2 1/4 tsp' },
      { name: 'Warm milk', amount: '1 cup' },
      { name: 'Sugar', amount: '1/4 cup' },
      { name: 'Eggs', amount: '2 large' },
      { name: 'Butter', amount: '4 tbsp, melted' },
      { name: 'Salt', amount: '1/2 tsp' },
      { name: 'Raspberry or strawberry jam', amount: '1/2 cup' },
      { name: 'Powdered sugar', amount: 'for dusting' },
      { name: 'Vegetable oil', amount: 'for frying' },
    ],
    instructions: [
      'Dissolve yeast in warm milk with a pinch of sugar. Let sit until foamy, about 5 minutes.',
      'In a large bowl, mix flour, sugar, and salt.',
      'Add eggs and melted butter to yeast mixture.',
      'Pour wet ingredients into flour. Mix until dough forms.',
      'Knead on floured surface 5-7 minutes until smooth.',
      'Place in oiled bowl, cover, and let rise 1 hour until doubled.',
      'Roll out to 1/2 inch thick. Cut into 2-inch circles.',
      'Place 1 tsp jam in center of half the circles.',
      'Top with remaining circles. Pinch edges to seal.',
      'Let rise 30 minutes.',
      'Heat 2 inches of oil to 350°F.',
      'Fry 2-3 minutes per side until golden.',
      'Drain on paper towels. Dust with powdered sugar while warm.',
    ],
  },
];

export const activities = [
  {
    id: 'afikoman-hunt',
    title: 'Afikoman Treasure Hunt',
    ageRange: '5-12',
    time: '30-45 minutes',
    category: 'Games',
    image: '🔍',
    imageSearchQuery: 'treasure hunt game children',
    description: 'Create clues and hide the afikoman for kids to find',
    materials: [
      'Afikoman (middle matzo)',
      'Paper for clues',
      'Small prizes or treats',
      'Envelopes or containers',
    ],
    instructions: [
      'Before the seder, write 5-7 clues that lead from one hiding spot to the next.',
      'Hide the afikoman in the final location.',
      'Give kids the first clue at the appropriate time during the seder.',
      'Let them work together to solve clues and find the afikoman.',
      'Celebrate when they find it!',
    ],
    culturalContext: 'The afikoman hunt keeps kids engaged during the seder. It\'s a playful way to involve them in the tradition while building excitement.',
  },
  {
    id: 'seder-plate-craft',
    title: 'Decorate Your Seder Plate',
    ageRange: '3-10',
    time: '45 minutes',
    category: 'Crafts',
    image: '🎨',
    imageSearchQuery: 'seder plate paper',
    description: 'Kids create their own seder plate with symbols',
    materials: [
      'Paper plates',
      'Markers, crayons, or paint',
      'Construction paper',
      'Glue',
      'Scissors',
    ],
    instructions: [
      'Give each child a paper plate.',
      'Have them draw or glue on the six seder plate symbols: shank bone, egg, bitter herbs, charoset, karpas, and maror.',
      'Label each item and explain what it represents.',
      'Display their plates at the seder table.',
    ],
    culturalContext: 'Creating their own seder plate helps kids understand the symbols and feel ownership over the tradition.',
  },
  {
    id: 'plagues-puppets',
    title: 'Ten Plagues Puppets',
    ageRange: '4-10',
    time: '1 hour',
    category: 'Crafts',
    image: '🎭',
    imageSearchQuery: 'puppets craft children',
    description: 'Make puppets to act out the ten plagues',
    materials: [
      'Paper bags or craft sticks',
      'Markers and crayons',
      'Googly eyes',
      'Construction paper',
      'Glue',
    ],
    instructions: [
      'Assign each child one or two plagues to create.',
      'Have them draw the plague on a paper bag or craft stick.',
      'Add details like frogs, locusts, or darkness.',
      'During the seder, have kids hold up their puppets when each plague is mentioned.',
    ],
    culturalContext: 'Making the plagues tangible helps kids understand the story and participate actively in the seder.',
  },
  {
    id: 'dreidel-game',
    title: 'Dreidel Tournament',
    ageRange: '6-12',
    time: '30-60 minutes',
    category: 'Games',
    image: '🎲',
    imageSearchQuery: 'dreidel game hanukkah',
    description: 'Classic dreidel game with chocolate coins',
    materials: [
      'Dreidel',
      'Chocolate coins (gelt)',
      'Small bowls or containers',
    ],
    instructions: [
      'Give each player 10-15 chocolate coins.',
      'Each player puts one coin in the center "pot."',
      'Take turns spinning the dreidel.',
      'Follow the Hebrew letter that lands face up: נ (take nothing), ג (take all), ה (take half), ש (put one in).',
      'Player with the most coins at the end wins!',
    ],
    culturalContext: 'Dreidel was played by Jews during times when studying Torah was forbidden. It\'s a symbol of resilience and joy.',
  },
  {
    id: 'story-time',
    title: 'Passover Story Time',
    ageRange: '3-8',
    time: '20-30 minutes',
    category: 'Stories',
    image: '📖',
    imageSearchQuery: 'children reading book',
    description: 'Age-appropriate retelling of the Exodus story',
    materials: [
      'Children\'s haggadah or storybook',
      'Comfortable reading space',
    ],
    instructions: [
      'Choose an age-appropriate version of the Passover story.',
      'Read together before or during the seder.',
      'Pause to ask questions and let kids share their thoughts.',
      'Use props or pictures to make it visual.',
    ],
    culturalContext: 'Stories connect us to our history. Telling the Exodus story to children keeps the tradition alive across generations.',
  },
  {
    id: 'blessing-cards',
    title: 'Make Blessing Cards',
    ageRange: '5-12',
    time: '30 minutes',
    category: 'Crafts',
    image: '✨',
    imageSearchQuery: 'cards craft paper',
    description: 'Create beautiful cards with Shabbat blessings',
    materials: [
      'Cardstock or heavy paper',
      'Markers, colored pencils',
      'Stickers or decorative elements',
    ],
    instructions: [
      'Have kids write or draw the Shabbat blessings on cards.',
      'Decorate with colors, patterns, or stickers.',
      'Use the cards during Friday night dinner.',
      'Kids can read their own cards to the family.',
    ],
    culturalContext: 'Creating blessing cards helps kids learn the words while making them feel personal and meaningful.',
  },
  {
    id: 'menorah-craft',
    title: 'Paper Menorah Craft',
    ageRange: '4-10',
    time: '30 minutes',
    category: 'Crafts',
    image: '🕎',
    imageSearchQuery: 'menorah craft children',
    description: 'Create a beautiful menorah from paper and candles',
    materials: [
      'Construction paper (blue, gold, yellow)',
      'Scissors',
      'Glue',
      'Markers',
      'Small candles or LED tea lights',
    ],
    instructions: [
      'Cut a rectangle from blue paper for the menorah base.',
      'Cut 9 small rectangles from gold paper for candle holders.',
      'Glue candle holders onto the base in a row.',
      'Decorate with markers or glitter.',
      'Place small candles or LED lights in each holder.',
      'Light one candle each night of Hanukkah!',
    ],
    culturalContext: 'Making a menorah helps kids understand the Hanukkah tradition and creates a beautiful decoration for the holiday.',
  },
  {
    id: 'hebrew-alphabet',
    title: 'Learn Hebrew Letters',
    ageRange: '5-12',
    time: '20-30 minutes',
    category: 'Learning',
    image: '🔤',
    imageSearchQuery: 'hebrew alphabet learning',
    description: 'Fun activities to learn the Hebrew alphabet',
    materials: [
      'Hebrew alphabet chart',
      'Paper and markers',
      'Playdough or clay',
      'Hebrew letter flashcards',
    ],
    instructions: [
      'Start with a few letters at a time (alef, bet, gimel).',
      'Have kids trace the letters with their fingers.',
      'Make letters out of playdough.',
      'Play matching games with flashcards.',
      'Sing Hebrew alphabet songs.',
      'Practice writing their name in Hebrew.',
    ],
    culturalContext: 'Learning Hebrew connects kids to Jewish culture and tradition. Making it fun and hands-on helps them engage with the language.',
  },
  {
    id: 'shabbat-candles',
    title: 'Light Shabbat Candles Together',
    ageRange: '3-12',
    time: '5 minutes',
    category: 'Ritual',
    image: '🕯️',
    imageSearchQuery: 'shabbat candles family',
    description: 'A simple ritual to welcome Shabbat',
    materials: [
      'Shabbat candles',
      'Candlesticks',
      'Matches (adult use)',
    ],
    instructions: [
      'Set up candles in candlesticks before sunset Friday.',
      'Have kids help place them on the table.',
      'Light the candles (adult does this).',
      'Cover eyes and say the blessing together.',
      'Enjoy the peaceful moment as Shabbat begins.',
    ],
    culturalContext: 'Lighting Shabbat candles marks the transition from the busy week to sacred time. Including kids makes it a family ritual they\'ll remember.',
  },
  {
    id: 'tzedakah-box',
    title: 'Decorate a Tzedakah Box',
    ageRange: '4-12',
    time: '45 minutes',
    category: 'Crafts',
    image: '💰',
    imageSearchQuery: 'charity box craft',
    description: 'Create a beautiful box for giving',
    materials: [
      'Small box or container',
      'Paint, markers, or decorative paper',
      'Glue',
      'Scissors',
      'Stickers or jewels',
    ],
    instructions: [
      'Choose a box with a slot in the top.',
      'Decorate with paint, markers, or paper.',
      'Add stickers, jewels, or other decorations.',
      'Write "Tzedakah" on it (help with spelling).',
      'Place it somewhere visible in the house.',
      'Add coins regularly and decide together where to donate.',
    ],
    culturalContext: 'Tzedakah (charity) is a core Jewish value. Having a tzedakah box teaches kids about giving and helping others.',
  },
  {
    id: 'holiday-scavenger',
    title: 'Holiday Scavenger Hunt',
    ageRange: '5-12',
    time: '30-45 minutes',
    category: 'Games',
    image: '🔍',
    imageSearchQuery: 'scavenger hunt children',
    description: 'Find Jewish symbols and items around the house',
    materials: [
      'List of items to find',
      'Paper and pen',
      'Small prizes (optional)',
    ],
    instructions: [
      'Create a list of items: menorah, dreidel, challah, kiddush cup, etc.',
      'Give each child a list and a bag.',
      'Set a timer and let them search the house.',
      'Check off items as they find them.',
      'First to find everything wins!',
      'Talk about what each item represents.',
    ],
    culturalContext: 'Scavenger hunts make learning about Jewish objects fun and interactive. Kids discover items they might not have noticed before.',
  },
  {
    id: 'story-illustration',
    title: 'Illustrate a Jewish Story',
    ageRange: '6-12',
    time: '45-60 minutes',
    category: 'Crafts',
    image: '🎨',
    imageSearchQuery: 'children drawing art',
    description: 'Draw pictures to go with a favorite story',
    materials: [
      'Paper or blank book',
      'Markers, crayons, or colored pencils',
      'Jewish storybook',
    ],
    instructions: [
      'Read a Jewish story together.',
      'Have kids draw their favorite scene.',
      'Create a whole book with multiple illustrations.',
      'Write captions explaining each picture.',
      'Share the finished book with family.',
    ],
    culturalContext: 'Illustrating stories helps kids understand and remember them. It also makes the stories their own.',
  },
  {
    id: 'sukkah-building',
    title: 'Build a Mini Sukkah',
    ageRange: '6-12',
    time: '1-2 hours',
    category: 'Crafts',
    image: '🏠',
    imageSearchQuery: 'sukkah hut temporary shelter branches',
    description: 'Create a small sukkah model for Sukkot',
    materials: [
      'Cardboard or popsicle sticks',
      'Glue or tape',
      'Scissors',
      'Natural materials (leaves, branches)',
      'String or yarn',
      'Markers or paint',
    ],
    instructions: [
      'Build a small frame using cardboard or popsicle sticks.',
      'Make sure it has at least three walls and a roof.',
      'Decorate the walls with drawings or paint.',
      'Cover the roof with branches, leaves, or paper cut to look like branches.',
      'Make sure you can see the sky through the roof (that\'s the tradition!).',
      'Add small decorations inside like paper fruit or drawings.',
      'Display your sukkah during Sukkot!',
    ],
    culturalContext: 'Sukkahs remind us of the temporary shelters the Israelites lived in during their journey in the desert. Building one helps kids understand this holiday and creates a special space for celebration.',
  },
  {
    id: 'tu-bshevat-planting',
    title: 'Plant a Tree for Tu B\'Shevat',
    ageRange: '4-12',
    time: '30 minutes',
    category: 'Ritual',
    image: '🌳',
    imageSearchQuery: 'planting tree sapling children garden',
    description: 'Celebrate the birthday of the trees by planting',
    materials: [
      'Small tree sapling or seeds',
      'Potting soil',
      'Pot or garden space',
      'Watering can',
      'Shovel (if planting outside)',
    ],
    instructions: [
      'Choose a tree or plant to grow (fruit trees are traditional).',
      'If using a pot, fill it with soil.',
      'Plant the sapling or seeds according to instructions.',
      'Water gently.',
      'Place in a sunny spot.',
      'Make a commitment to care for it together.',
      'Watch it grow throughout the year!',
    ],
    culturalContext: 'Tu B\'Shevat is the birthday of the trees. Planting something teaches kids about caring for the earth and connects them to the cycle of growth and renewal.',
  },
  {
    id: 'shavuot-crowns',
    title: 'Make Shavuot Crowns',
    ageRange: '4-10',
    time: '30 minutes',
    category: 'Crafts',
    image: '👑',
    imageSearchQuery: 'crown craft paper flowers children',
    description: 'Create beautiful crowns to celebrate receiving the Torah',
    materials: [
      'Construction paper or cardstock',
      'Scissors',
      'Glue',
      'Markers, crayons, or paint',
      'Stickers or jewels',
      'Tape or stapler',
    ],
    instructions: [
      'Cut a strip of paper long enough to fit around your head.',
      'Decorate with drawings of flowers, fruits, or Torah scrolls.',
      'Add stickers, jewels, or other decorations.',
      'Cut out shapes like flowers or stars to glue on top.',
      'Tape or staple the ends together to make a crown.',
      'Wear your crown during Shavuot celebrations!',
    ],
    culturalContext: 'Shavuot celebrates receiving the Torah. Making crowns helps kids feel special and connected to this important moment in Jewish history.',
  },
  {
    id: 'hebrew-songs',
    title: 'Learn Hebrew Songs',
    ageRange: '3-12',
    time: '15-30 minutes',
    category: 'Learning',
    image: '🎵',
    imageSearchQuery: 'children singing together',
    description: 'Sing and learn Hebrew through music',
    materials: [
      'Hebrew song lyrics (printed or on screen)',
      'Music player (optional)',
      'Simple instruments (tambourine, shakers)',
    ],
    instructions: [
      'Start with simple songs like "Shalom Aleichem" or "Hava Nagila."',
      'Learn the words together, one line at a time.',
      'Practice the melody by listening or singing along.',
      'Add hand motions or dance moves.',
      'Use simple instruments to keep rhythm.',
      'Sing together regularly to build familiarity.',
      'Talk about what the words mean.',
    ],
    culturalContext: 'Music is a powerful way to learn language and connect with tradition. Hebrew songs carry the sounds and rhythms of Jewish culture, making them memorable and meaningful.',
  },
];

export const stories = [
  {
    id: 'exodus-story',
    title: 'The Story of Exodus',
    ageRange: '5-12',
    category: 'Holiday',
    image: '🌊',
    imageSearchQuery: 'red sea parting water',
    description: 'The story of how the Israelites left Egypt',
    content: `Long ago, the Jewish people lived in Egypt as slaves. They worked very hard building cities for the Pharaoh, but they were not free.

A man named Moses heard a voice calling to him from a burning bush. The voice said, "I am God. Go to Pharaoh and tell him: Let my people go!"

Moses was afraid, but he went to Pharaoh and said, "Let my people go!" But Pharaoh said no. So God sent ten plagues to show Pharaoh that the Jewish people should be free.

After the last plague, Pharaoh finally said yes. The Jewish people left Egypt in a hurry—so fast they didn't even have time to let their bread rise! That's why we eat matzo on Passover.

When they reached the Red Sea, it seemed like they were trapped. But then, a miracle happened: the sea split in two, and the Jewish people walked through on dry land to freedom.

We tell this story every year at Passover to remember that freedom is precious, and that we should help others be free too.`,
    readAloud: true,
  },
  {
    id: 'hanukkah-story',
    title: 'The Hanukkah Miracle',
    ageRange: '5-12',
    category: 'Holiday',
    image: '🕎',
    imageSearchQuery: 'menorah candles light',
    description: 'How a small amount of oil lasted eight days',
    content: `A long time ago, the Jewish people lived in Israel. A mean king named Antiochus told them they couldn't practice their religion anymore. He even put a statue in their holy temple!

A group of brave people called the Maccabees fought back. They wanted to be free to practice their religion. After a long battle, they won!

When they went back to the temple, they found it in ruins. They wanted to light the menorah, but there was only enough oil for one day. It would take eight days to make more oil.

But then, a miracle happened! The oil that should have lasted only one day burned for eight whole days! That's why we celebrate Hanukkah for eight nights.

We light the menorah to remember this miracle and to remember that even when things seem impossible, hope and light can shine through.`,
    readAloud: true,
  },
  {
    id: 'queen-esther',
    title: 'Queen Esther and Purim',
    ageRange: '6-12',
    category: 'Holiday',
    image: '👑',
    imageSearchQuery: 'queen crown royal',
    description: 'The brave queen who saved her people',
    content: `Once upon a time, there was a beautiful and brave queen named Esther. She was Jewish, but the king didn't know that.

A mean man named Haman wanted to hurt all the Jewish people. He made a plan to do something very bad.

Esther's cousin Mordecai found out about the plan. He told Esther, "You must go to the king and tell him about Haman's plan. You're the only one who can save our people!"

Esther was scared. In those days, you couldn't just go talk to the king whenever you wanted. If he didn't want to see you, you could be in big trouble!

But Esther was brave. She said, "If I must die, I will die, but I will try to save my people."

She went to the king and told him about Haman's evil plan. The king was angry at Haman and stopped his plan. The Jewish people were saved!

We celebrate Purim to remember Queen Esther's bravery. We dress up, make noise, and eat hamantaschen cookies shaped like Haman's hat.`,
    readAloud: true,
  },
  {
    id: 'shabbat-rest',
    title: 'Why We Rest on Shabbat',
    ageRange: '4-10',
    category: 'Tradition',
    image: '🕯️',
    imageSearchQuery: 'shabbat rest candles',
    description: 'The story of the seventh day',
    content: `A long, long time ago, when the world was being created, God worked for six days. On the first day, God made light. On the second day, God made the sky. On the third day, God made land and plants. On the fourth day, God made the sun and stars. On the fifth day, God made fish and birds. On the sixth day, God made animals and people.

On the seventh day, God rested. God looked at everything that was made and said, "This is good."

That's why we have Shabbat—a special day of rest. Every week, from Friday evening to Saturday evening, we take time to rest, just like God did.

On Shabbat, we light candles, eat special food, spend time with family, and don't work. It's a time to slow down and appreciate the good things in our lives.

Shabbat is like a weekly gift—a whole day to just be, to connect with the people we love, and to remember what's important.`,
    readAloud: true,
  },
  {
    id: 'welcoming-strangers',
    title: 'Welcoming Strangers',
    ageRange: '5-12',
    category: 'Values',
    image: '🏠',
    imageSearchQuery: 'hospitality table family',
    description: 'The Jewish value of hospitality',
    content: `In Jewish tradition, there's a very important value called "hachnasat orchim"—welcoming guests. It means we should always be kind and welcoming to people, especially those who might be new or feel left out.

The story goes that our ancestor Abraham was famous for his hospitality. He would sit outside his tent, waiting for travelers. When he saw someone coming, he would run to greet them, invite them in, and make sure they had food and a place to rest.

This tradition teaches us that everyone deserves to feel welcome. When we have Shabbat dinner or holiday celebrations, we often invite others to join us. We make room at the table, literally and figuratively.

Being welcoming doesn't mean you have to have a big fancy meal. It means being kind, making space for others, and treating everyone with respect. It's about creating a sense of belonging.

This is why many Jewish families have an open-door policy—there's always room for one more person at the table.`,
    readAloud: true,
  },
  {
    id: 'creation-story',
    title: 'The Seven Days of Creation',
    ageRange: '4-10',
    category: 'Tradition',
    image: '🌍',
    imageSearchQuery: 'nature creation world',
    description: 'How the world came to be',
    content: `In the beginning, there was nothing. Just darkness and emptiness. Then, something amazing happened.

On the first day, God said, "Let there be light!" And there was light. God separated the light from the darkness, calling the light "day" and the darkness "night."

On the second day, God made the sky, separating the waters above from the waters below.

On the third day, God gathered the waters together to make seas, and made dry land appear. God also made all the plants and trees grow on the land.

On the fourth day, God made the sun to shine during the day and the moon and stars to shine at night.

On the fifth day, God filled the seas with fish and the sky with birds of all kinds.

On the sixth day, God made all the animals—big and small, wild and tame. And then God made people, saying we should take care of the earth and all its creatures.

On the seventh day, God rested. God looked at everything that was made and said, "This is very good."

That's why we rest on Shabbat—to remember that after creating, we need time to rest and appreciate what we have.`,
    readAloud: true,
  },
  {
    id: 'noah-ark',
    title: 'Noah and the Ark',
    ageRange: '5-12',
    category: 'Tradition',
    image: '🚢',
    imageSearchQuery: 'ark rainbow animals',
    description: 'The story of the great flood and the rainbow',
    content: `Long ago, there was a man named Noah who was very good and kind. God saw that many people in the world were not being kind to each other, and God was sad.

God told Noah, "I'm going to send a great flood. Build a big boat called an ark. Take your family and two of every kind of animal—one male and one female."

Noah did exactly what God asked. He built a huge ark and gathered animals of every kind: elephants and giraffes, lions and tigers, birds and bugs, and so many more.

When the ark was ready, it started to rain. It rained for forty days and forty nights! The whole earth was covered with water, but Noah, his family, and all the animals were safe in the ark.

After the rain stopped, the water slowly went away. Noah sent out a dove to see if there was dry land. The dove came back with an olive branch in its beak—a sign that the land was growing again!

When they finally left the ark, God made a beautiful rainbow in the sky. God said, "This rainbow is a promise. I will never flood the whole earth again. Whenever you see a rainbow, remember my promise."

That's why rainbows are special—they remind us of God's promise and that after every storm, there's hope and new beginnings.`,
    readAloud: true,
  },
  {
    id: 'david-goliath',
    title: 'David and Goliath',
    ageRange: '6-12',
    category: 'Tradition',
    image: '⚔️',
    imageSearchQuery: 'david slingshot story',
    description: 'The young shepherd who faced a giant',
    content: `A long time ago, there was a giant warrior named Goliath. He was so big and strong that everyone was afraid of him. He challenged the army of Israel, saying, "Send someone to fight me! If they win, we'll surrender. If I win, you'll surrender."

All the soldiers were too afraid to fight Goliath. But there was a young shepherd boy named David who wasn't afraid. David said to the king, "I'll fight Goliath!"

The king was worried. "You're just a boy! Goliath is a giant warrior!"

But David said, "I've protected my sheep from lions and bears. I trust that I can protect my people too."

So David went to face Goliath. He didn't wear heavy armor or carry a sword. Instead, he took his slingshot and five smooth stones from a stream.

When Goliath saw David, he laughed. "You're just a boy! Come here and I'll feed you to the birds!"

But David wasn't afraid. He put a stone in his slingshot, swung it around, and let it fly. The stone hit Goliath right in the forehead, and the giant fell down.

David had won! Not because he was the biggest or strongest, but because he was brave, clever, and believed in doing what was right.

This story teaches us that you don't have to be the biggest or strongest to be brave. Sometimes, courage and cleverness are more powerful than size and strength.`,
    readAloud: true,
  },
  {
    id: 'wisdom-solomon',
    title: 'King Solomon\'s Wisdom',
    ageRange: '6-12',
    category: 'Values',
    image: '👑',
    imageSearchQuery: 'wisdom king ancient',
    description: 'The wise king who solved a difficult problem',
    content: `King Solomon was known as the wisest king who ever lived. People came from far and wide to ask for his advice.

One day, two women came to see him. They were both holding a baby, and they were arguing.

The first woman said, "This is my baby! The other woman's baby died, and she took mine!"

The second woman said, "No! This is my baby! Her baby died, and she took mine!"

How could the king know which woman was telling the truth? It seemed impossible.

But King Solomon was very wise. He said, "Bring me a sword. I'll cut the baby in half, and each of you can have half."

The first woman cried out, "No! Don't hurt the baby! Give it to her instead!"

But the second woman said, "Fine. Cut it in half. If I can't have the baby, neither can she."

Then King Solomon knew the truth. He said, "Give the baby to the first woman. A real mother would rather lose her child than see it hurt. She is the true mother."

The first woman was so happy! She got her baby back, and everyone was amazed by King Solomon's wisdom.

This story teaches us that wisdom isn't just about knowing facts—it's about understanding people's hearts and finding creative solutions to difficult problems.`,
    readAloud: true,
  },
  {
    id: 'ruth-story',
    title: 'The Story of Ruth',
    ageRange: '6-12',
    category: 'Values',
    image: '🌾',
    imageSearchQuery: 'ruth field grain harvest kindness',
    description: 'A story of loyalty, kindness, and belonging',
    content: `Once upon a time, there was a woman named Naomi who lived in a place called Moab with her husband and two sons. Her sons married women from Moab named Orpah and Ruth.

Then, something very sad happened. Naomi's husband and both of her sons died. Naomi was left all alone, except for her two daughters-in-law.

Naomi decided to go back to her homeland of Israel. She told Orpah and Ruth, "You should go back to your families. I have nothing to give you."

Orpah went back to her family, but Ruth said something beautiful: "Don't ask me to leave you. Where you go, I will go. Where you stay, I will stay. Your people will be my people, and your God will be my God."

So Ruth went with Naomi to Israel. They were very poor, and Ruth worked hard in the fields, gathering leftover grain so they could eat.

A kind man named Boaz owned the fields. He saw how hard Ruth worked and how kind she was to Naomi. He made sure Ruth had enough grain and was safe.

Eventually, Boaz and Ruth got married, and they had a son. Naomi was so happy! She helped take care of the baby, and her sadness turned to joy.

Ruth's story teaches us about loyalty—staying with people we love even when it's hard. It also teaches us that kindness and hard work are important, and that we can find family in unexpected places.`,
    readAloud: true,
  },
  {
    id: 'joseph-coat',
    title: 'Joseph and His Colorful Coat',
    ageRange: '5-12',
    category: 'Tradition',
    image: '🌈',
    imageSearchQuery: 'colorful coat dreamer brothers',
    description: 'The story of a dreamer and his brothers',
    content: `Joseph was one of twelve brothers, and he was his father Jacob's favorite son. Jacob loved Joseph so much that he gave him a special coat—a beautiful, colorful coat that was unlike anything his brothers had.

Joseph's brothers were jealous. They didn't like that their father loved Joseph more than them.

One day, Joseph had a dream. He dreamed that he and his brothers were in a field, and their bundles of grain bowed down to his bundle. He told his brothers about the dream, and they got even more jealous.

Then Joseph had another dream. This time, he dreamed that the sun, moon, and eleven stars all bowed down to him. When he told his family, even his father was a little upset!

One day, Joseph's brothers were taking care of the sheep far from home. Their father sent Joseph to check on them. When the brothers saw Joseph coming, they decided to do something mean. They took his beautiful coat and threw him into a deep pit.

But then, some traders came by. The brothers decided to sell Joseph to them instead of leaving him in the pit. The traders took Joseph to Egypt, far away from his family.

The brothers took Joseph's coat, tore it, and put animal blood on it. They showed it to their father and said, "A wild animal must have eaten Joseph!" Their father was heartbroken.

But Joseph's story wasn't over. In Egypt, he worked hard and became very important. He helped the Pharaoh understand dreams and saved Egypt from a terrible famine. Eventually, his brothers came to Egypt looking for food, and Joseph forgave them.

The story teaches us that even when bad things happen, we can grow and become stronger. It also teaches us about forgiveness and the importance of family.`,
    readAloud: true,
  },
  {
    id: 'tower-babel',
    title: 'The Tower of Babel',
    ageRange: '5-10',
    category: 'Tradition',
    image: '🗼',
    imageSearchQuery: 'tower construction building ancient',
    description: 'A story about working together and understanding differences',
    content: `A long, long time ago, everyone in the world spoke the same language. They could all understand each other perfectly!

The people decided they wanted to build something amazing—a tower so tall it would reach all the way up to the sky. They wanted to show how powerful and clever they were.

So everyone worked together. They made bricks and built the tower higher and higher. They were very proud of what they were building.

But something happened. As they built the tower, people started speaking different languages. Suddenly, someone would say something, and others couldn't understand what they meant!

"Pass me a brick!" someone would say, but others would hear it as "Bring me a stick!" or "Pass me a trick!"

People got confused and frustrated. They couldn't work together anymore because they couldn't understand each other. The tower building stopped, and people spread out to different parts of the world, each group speaking their own language.

This story teaches us that when we can't communicate, it's hard to work together. But it also teaches us that having different languages and cultures is part of what makes the world interesting. We all have something unique to share, and we can learn from each other even when we speak differently.

The story reminds us to be patient with people who speak different languages and to find ways to understand each other, even when it's challenging.`,
    readAloud: true,
  },
];

export const getContentByCategory = (category) => {
  switch (category) {
    case 'recipes':
      return recipes;
    case 'activities':
      return activities;
    case 'stories':
      return stories;
    default:
      return [];
  }
};

export const getContentById = (category, id) => {
  const content = getContentByCategory(category);
  return content.find((item) => item.id === id);
};
